import { render, staticRenderFns } from "./ChatCommandCard.vue?vue&type=template&id=8ee6b506"
import script from "./ChatCommandCard.vue?vue&type=script&lang=js"
export * from "./ChatCommandCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports